import { formatDateYYYYMMDD } from "../helpers/utils";

export type NutritionEntity = {

    nutritionID: string;
    farmID: string;
    farmName: string;
    blockID: string;
    blockName: string;
    productID: string;
    productName: string;
    quantity: number;
    quantityPlanned: number;
    quantityTotalConsumed: number;
    remainingAmount: number;
    unitID: string;
    imageURL: string;
    executedDate: string;
    plannedDate: string;
    mode: string;
    isDirty: boolean;
    note: string;
    hectares: number;

    actualQuantity?: number;
    instanceType?: 'NutritionProduct';
}


export type NutritionApplicationGroup = {
    groupID: number;
    applicationDate: Date;
    applications: NutritionEntity[];    
}

export type NutritionApplications = {
    applicationsExecutedGroups: NutritionApplicationGroup[];
    applicationsPlannedGroups: NutritionApplicationGroup[];
}

export const blankNutritionEntity = {

    nutritionID: '',
    farmID: '',
    farmName: '',
    blockID: '',
    blockName: '',
    productID: '',
    productName: '',
    quantity: 0,
    quantityPlanned: 0,
    quantityTotalConsumed: 0,
    remainingAmount: 0,
    uom: '',
    unitID: '', 
    imageURL: '',
    executedDate:  formatDateYYYYMMDD(new Date()) || '',
    plannedDate:  formatDateYYYYMMDD(new Date()) || '',
    mode: '',
    isDirty: false,
    note: '',
    hectares: 0
}